import { configureStore } from '@reduxjs/toolkit';
import themeReducer from './themeSlice';
import userPreferencesReducer from './userPreferencesSlice';

// Define the shape of our state
export interface RootState {
  theme: {
    isDarkMode: boolean;
  };
  userPreferences: {
    soundEnabled: boolean;
    autoplay: boolean;
    savedSections: string[];
  };
}

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    userPreferences: userPreferencesReducer,
  },
});

// Inferred type: {theme: ThemeState, userPreferences: UserPreferencesState}
export type AppDispatch = typeof store.dispatch;

// Create a type-safe useSelector hook
declare module 'react-redux' {
  interface DefaultRootState extends RootState {}
} 